/** @jsxImportSource @emotion/react */
import { HST_STEPS, PSG_STEPS } from 'helpers/orderStateHelpers'
import { FollowUpNamespace, Order } from 'store/types'
import { CaptureConsent } from './CaptureConsent'
import { DeviceShipping } from './DeviceShipping'
import { FollowUpSection } from './FollowUpSection'
import { PatientScheduling } from './PatientScheduling'
import { PatientTesting } from './PatientTesting'
import { PreAuthorization } from './PreAuthorization'
import { PsgPatientScheduling } from './PsgPatientScheduling'

interface IProps {
  orderState: { hstStep: HST_STEPS }
  order: Order
}

const getHstDeviceLifecycleFollowUpNamespace = (order: Order) => {
  const isPendingReturnBucket = order?.bucket === 'PENDING_RETURN'
  const hasPendingReturnFollowUp = order?.followUpsList?.some(
    (followUp) => followUp.namespace === FollowUpNamespace.HST,
  )

  if (isPendingReturnBucket || hasPendingReturnFollowUp) {
    return FollowUpNamespace.HST
  }

  return FollowUpNamespace.HST_DEVICE
}

export const HstWorkflow = ({ orderState, order }: IProps) => {
  const { hstStep } = orderState
  const deviceLifecycleFollowUpNamespace = getHstDeviceLifecycleFollowUpNamespace(order)

  if (hstStep === HST_STEPS.PATIENT_CONSENT) {
    return <CaptureConsent order={order} />
  }
  if (hstStep === HST_STEPS.OFFICE_NOTES_VERIFICATION) {
    return null
  }
  if (hstStep === HST_STEPS.PRE_AUTHORIZATION) {
    return <PreAuthorization order={order} />
  }
  if (hstStep === HST_STEPS.PATIENT_SCHEDULING) {
    return <PatientScheduling order={order} />
  }

  return (
    <>
      <div css={{ padding: 20 }}>
        <FollowUpSection order={order} namespace={deviceLifecycleFollowUpNamespace} />
      </div>
      <DeviceShipping order={order} orderState={orderState} />
      <PatientTesting order={order} />
    </>
  )
}

interface IPropsPsg {
  step: PSG_STEPS
  order: Order
}

export const PsgWorkflow = ({ step, order }: IPropsPsg) => {
  if (step === PSG_STEPS.PATIENT_CONSENT) {
    return <CaptureConsent order={order} />
  }
  if (step === PSG_STEPS.PRE_AUTHORIZATION) {
    return <PreAuthorization order={order} />
  }

  return (
    <>
      <div css={{ padding: 20 }}>
        <FollowUpSection order={order} />
      </div>
      {order?.bucket !== 'COMPLETED' && <PsgPatientScheduling order={order} />}
    </>
  )
}
